export default __webpack_public_path__ + "static/media/menuFavorito.98e75991.svg";